module.exports = [
  {
    "Race": "Majority Non-Black",
    "Age": 55,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 56,
    "Count": 1
  },
  {
    "Race": "Majority Non-Black",
    "Age": 57,
    "Count": 1
  },
  {
    "Race": "Majority Non-Black",
    "Age": 58,
    "Count": 1
  },
  {
    "Race": "Majority Non-Black",
    "Age": 59,
    "Count": 1
  },
  {
    "Race": "Majority Non-Black",
    "Age": 60,
    "Count": 3
  },
  {
    "Race": "Majority Non-Black",
    "Age": 61,
    "Count": 3
  },
  {
    "Race": "Majority Non-Black",
    "Age": 62,
    "Count": 11
  },
  {
    "Race": "Majority Non-Black",
    "Age": 63,
    "Count": 8
  },
  {
    "Race": "Majority Non-Black",
    "Age": 64,
    "Count": 16
  },
  {
    "Race": "Majority Non-Black",
    "Age": 65,
    "Count": 22
  },
  {
    "Race": "Majority Non-Black",
    "Age": 66,
    "Count": 45
  },
  {
    "Race": "Majority Non-Black",
    "Age": 67,
    "Count": 93
  },
  {
    "Race": "Majority Non-Black",
    "Age": 68,
    "Count": 154
  },
  {
    "Race": "Majority Non-Black",
    "Age": 69,
    "Count": 259
  },
  {
    "Race": "Majority Non-Black",
    "Age": 70,
    "Count": 439
  },
  {
    "Race": "Majority Non-Black",
    "Age": 71,
    "Count": 694
  },
  {
    "Race": "Majority Non-Black",
    "Age": 72,
    "Count": 1199
  },
  {
    "Race": "Majority Non-Black",
    "Age": 73,
    "Count": 1859
  },
  {
    "Race": "Majority Non-Black",
    "Age": 74,
    "Count": 2505
  },
  {
    "Race": "Majority Non-Black",
    "Age": 75,
    "Count": 3723
  },
  {
    "Race": "Majority Non-Black",
    "Age": 76,
    "Count": 4903
  },
  {
    "Race": "Majority Non-Black",
    "Age": 77,
    "Count": 5574
  },
  {
    "Race": "Majority Non-Black",
    "Age": 78,
    "Count": 6170
  },
  {
    "Race": "Majority Non-Black",
    "Age": 79,
    "Count": 6372
  },
  {
    "Race": "Majority Non-Black",
    "Age": 80,
    "Count": 6420
  },
  {
    "Race": "Majority Non-Black",
    "Age": 81,
    "Count": 6092
  },
  {
    "Race": "Majority Non-Black",
    "Age": 82,
    "Count": 4722
  },
  {
    "Race": "Majority Non-Black",
    "Age": 83,
    "Count": 3160
  },
  {
    "Race": "Majority Non-Black",
    "Age": 84,
    "Count": 2211
  },
  {
    "Race": "Majority Non-Black",
    "Age": 85,
    "Count": 1492
  },
  {
    "Race": "Majority Non-Black",
    "Age": 86,
    "Count": 887
  },
  {
    "Race": "Majority Non-Black",
    "Age": 87,
    "Count": 529
  },
  {
    "Race": "Majority Non-Black",
    "Age": 88,
    "Count": 284
  },
  {
    "Race": "Majority Non-Black",
    "Age": 89,
    "Count": 162
  },
  {
    "Race": "Majority Non-Black",
    "Age": 90,
    "Count": 56
  },
  {
    "Race": "Majority Non-Black",
    "Age": 91,
    "Count": 22
  },
  {
    "Race": "Majority Non-Black",
    "Age": 92,
    "Count": 15
  },
  {
    "Race": "Majority Non-Black",
    "Age": 93,
    "Count": 8
  },
  {
    "Race": "Majority Non-Black",
    "Age": 94,
    "Count": 3
  },
  {
    "Race": "Majority Black",
    "Age": 55,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 56,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 57,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 58,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 59,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 60,
    "Count": 3
  },
  {
    "Race": "Majority Black",
    "Age": 61,
    "Count": 1
  },
  {
    "Race": "Majority Black",
    "Age": 62,
    "Count": 6
  },
  {
    "Race": "Majority Black",
    "Age": 63,
    "Count": 10
  },
  {
    "Race": "Majority Black",
    "Age": 64,
    "Count": 21
  },
  {
    "Race": "Majority Black",
    "Age": 65,
    "Count": 31
  },
  {
    "Race": "Majority Black",
    "Age": 66,
    "Count": 91
  },
  {
    "Race": "Majority Black",
    "Age": 67,
    "Count": 104
  },
  {
    "Race": "Majority Black",
    "Age": 68,
    "Count": 196
  },
  {
    "Race": "Majority Black",
    "Age": 69,
    "Count": 232
  },
  {
    "Race": "Majority Black",
    "Age": 70,
    "Count": 324
  },
  {
    "Race": "Majority Black",
    "Age": 71,
    "Count": 425
  },
  {
    "Race": "Majority Black",
    "Age": 72,
    "Count": 687
  },
  {
    "Race": "Majority Black",
    "Age": 73,
    "Count": 611
  },
  {
    "Race": "Majority Black",
    "Age": 74,
    "Count": 563
  },
  {
    "Race": "Majority Black",
    "Age": 75,
    "Count": 479
  },
  {
    "Race": "Majority Black",
    "Age": 76,
    "Count": 431
  },
  {
    "Race": "Majority Black",
    "Age": 77,
    "Count": 370
  },
  {
    "Race": "Majority Black",
    "Age": 78,
    "Count": 289
  },
  {
    "Race": "Majority Black",
    "Age": 79,
    "Count": 229
  },
  {
    "Race": "Majority Black",
    "Age": 80,
    "Count": 171
  },
  {
    "Race": "Majority Black",
    "Age": 81,
    "Count": 99
  },
  {
    "Race": "Majority Black",
    "Age": 82,
    "Count": 70
  },
  {
    "Race": "Majority Black",
    "Age": 83,
    "Count": 38
  },
  {
    "Race": "Majority Black",
    "Age": 84,
    "Count": 27
  },
  {
    "Race": "Majority Black",
    "Age": 85,
    "Count": 20
  },
  {
    "Race": "Majority Black",
    "Age": 86,
    "Count": 5
  },
  {
    "Race": "Majority Black",
    "Age": 87,
    "Count": 2
  },
  {
    "Race": "Majority Black",
    "Age": 88,
    "Count": 4
  },
  {
    "Race": "Majority Black",
    "Age": 89,
    "Count": 2
  },
  {
    "Race": "Majority Black",
    "Age": 90,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 91,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 92,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 93,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 94,
    "Count": 0
  }
]
